var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type)?_c('svg',{staticClass:"icon"},[_c('use',{attrs:{"xlink:href":_vm.iconName}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }